// Toast type constants for consistent use
export const TOAST_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
};

// Default toast configuration and utilities
const DEFAULT_ICONS = {
  [TOAST_TYPES.SUCCESS]: 'check circle',
  [TOAST_TYPES.ERROR]: 'times circle',
  [TOAST_TYPES.WARNING]: 'exclamation triangle',
  [TOAST_TYPES.INFO]: 'info circle'
};

export const getDefaultIcon = (type) => DEFAULT_ICONS[type] || DEFAULT_ICONS[TOAST_TYPES.INFO];

export const defaultToastConfig = {
  position: 'top-right',
  maxToasts: 5,
  defaultDuration: 3000, // Default duration in milliseconds (3 seconds)
  durations: {
    [TOAST_TYPES.SUCCESS]: 3000,
    [TOAST_TYPES.ERROR]: 4000, // Errors stay a bit longer for visibility
    [TOAST_TYPES.WARNING]: 3500,
    [TOAST_TYPES.INFO]: 3000,
  },
  styles: {
    [TOAST_TYPES.SUCCESS]: {
      borderLeftColor: '#23B80B',
      iconColor: '#23B80B',
      backgroundColor: '#e8f5e9',
      textColor: '#1b5e20',
    },
    [TOAST_TYPES.ERROR]: {
      borderLeftColor: '#de0909',
      iconColor: '#de0909',
      backgroundColor: '#ffebee',
      textColor: '#c62828',
    },
    [TOAST_TYPES.WARNING]: {
      borderLeftColor: '#F5A623',
      iconColor: '#F5A623',
      backgroundColor: '#fff9e6',
      textColor: '#e65100',
    },
    [TOAST_TYPES.INFO]: {
      borderLeftColor: '#008B8F',
      iconColor: '#008B8F',
      backgroundColor: '#e0f7fa',
      textColor: '#006064',
    },
  },
  icons: {
    [TOAST_TYPES.SUCCESS]: 'check circle',
    [TOAST_TYPES.ERROR]: 'times circle',
    [TOAST_TYPES.WARNING]: 'exclamation triangle',
    [TOAST_TYPES.INFO]: 'info circle',
  },
  animations: {
    enterDuration: 300,
    exitDuration: 300,
    easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  showIcon: true,
  showProgressBar: true,
  clickToClose: true,
  containerStyles: {
    zIndex: 10000,
  },
  toastStyles: {
    minWidth: '300px',
    maxWidth: '500px',
    borderRadius: '8px',
    padding: '16px',
    gap: '12px',
  },
  mobileBreakpoint: 768,
  mobile: {
    minWidth: '280px',
    maxWidth: 'calc(100vw - 40px)',
  },
};

const mergeNested = (defaultObj, userObj) => ({
  ...defaultObj,
  ...(userObj || {}),
});

export const mergeConfig = (userConfig = {}) => {
  const nestedKeys = ['durations', 'styles', 'icons', 'animations', 'containerStyles', 'toastStyles', 'mobile'];
  const merged = { ...defaultToastConfig, ...userConfig };
  
  nestedKeys.forEach(key => {
    if (userConfig[key]) {
      merged[key] = mergeNested(defaultToastConfig[key], userConfig[key]);
    }
  });
  
  return merged;
};

